import PickUpLocationInfoContainer from './PickUpLocationInfoContainer';

export default PickUpLocationInfoContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/PickUpLocationInfo/index.js